import React from 'react';

/**
 * Les matrices de permissions métier et les positions (regroupement de rôles IAM)
 * sont gérées dans la console d’administration plateforme, pas dans l’app Entrea.
 */
const RolesPermissions = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-10">
      <div className="rounded-xl border border-entrea-sky/40 bg-entrea-panel shadow-sm p-6 sm:p-8">
        <h1 className="text-xl font-bold text-gray-900 mb-2">Rôles & permissions</h1>
        <p className="text-gray-700 leading-relaxed mb-4">
          La configuration des <strong>rôles IAM</strong>, de la <strong>matrice Entrea</strong> et des{' '}
          <strong>positions métier</strong> (une position = plusieurs clés de rôle) se fait dans la{' '}
          <strong>console admin Uruganda</strong>, au niveau du projet.
        </p>
        <p className="text-sm text-gray-600 mb-6">
          Dans Entrea, les utilisateurs se voient assigner une <strong>position</strong> sur le projet ; les
          permissions effectives combinent cette position avec les rôles techniques IAM lorsque nécessaire.
        </p>
        <p className="text-xs text-gray-500">
          Accès réservé aux administrateurs de la plateforme ou de l’organisation selon votre contrat.
        </p>
      </div>
    </div>
  );
};

export default RolesPermissions;
